import LanguageEN from '@/languages/en.json';
import LanguageSE from '@/languages/se.json';
import LanguageNO from '@/languages/no.json';
import LanguageIS from '@/languages/is.json';

export default {
  en: LanguageEN,
  se: LanguageSE,
  no: LanguageNO,
  is: LanguageIS
};
